export type AnalyticsTab = {
  label: string;
  name: string;
};

export const resolveActiveTab = (
  tabs: AnalyticsTab[],
  selectedTab: string,
): { activeIndex: number; activeTab: string } => {
  const tabIndex = tabs.findIndex(tab => tab.name === selectedTab);
  const activeIndex = tabIndex >= 0 ? tabIndex : 0;
  const activeTab = tabs[activeIndex]?.name ?? 'overview';
  return { activeIndex, activeTab };
};

type GetAnalyticsTabsOptions = {
  enableCHDashboardAnalytics?: boolean;
  showAdminPanel?: boolean;
};

export const getAnalyticsTabs = ({
  enableCHDashboardAnalytics,
  showAdminPanel,
}: GetAnalyticsTabsOptions): AnalyticsTab[] => {
  const tabs: AnalyticsTab[] = [
    { label: 'overview', name: 'overview' },
    { label: 'events', name: 'events' },
    { label: 'series', name: 'series' },
    {
      label: enableCHDashboardAnalytics ? 'contacts' : 'registrants',
      name: 'registrants',
    },
  ];

  if (enableCHDashboardAnalytics) {
    tabs.push({ label: 'videos', name: 'videos' });
  }

  if (showAdminPanel) {
    tabs.push({ label: 'admin.title', name: 'admin' });
  }

  return tabs;
};
